<ng-container *ngIf="data">
  <mb-card-base class="column-card content-top">
    <figure *ngIf="data.image" media>
      <mb-image [media]="data.image"></mb-image>
    </figure>
    <h4 class="test-car-title" headline>{{ data.title }}</h4>
    <div class="test-car-specs" text>
      <div class="key-item-pair copy-m" *ngFor="let item of data.cardSpecs">
        <span
          ><strong>{{ item.label }}</strong></span
        >
        <span>{{ item.value }}</span>
      </div>
    </div>
    <span *ngIf="data.fuelLabel" class="fuel-label copy-s" [innerHTML]="data.fuelLabel" fuel-label></span>
    <mb-action-container
      *ngIf="data.document"
      [resource]="data.document"
      [buttonItems]="actions"
      (actionClick)="actionClick.emit($event)"
      action-container
    >
    </mb-action-container>
  </mb-card-base>
</ng-container>
